import { FormEvent, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from '../components';
import { FormInput } from '../components/forms/FormInput';
import { PasswordInput } from '../components/forms/PasswordInput';
import { RequestPasswordReset } from '../components/buttons/PasswordReset';

export const Route = createFileRoute('/enroll')({
  component: Enroll,
});

function Enroll() {
  // LOCAL STATE FOR USERNAME AND PASSWORD
  const [email, setEmail] = useState(window.localStorage.getItem('initialEmail') || '');
  const [password, setPassword] = useState('');
  const [working, setWorking] = useState(false);

  // AUTH HANDLING
  const { firebaseLogin } = useAuth();
  const { currentUser } = useAuth();
  const handleLogin = async (e: FormEvent) => {
    e.preventDefault();
    setWorking(true);
    try {
      await firebaseLogin(email, password);
    } catch (error) {
      alert(
        "We couldn't log you in. Please try again. Or if you're having trouble, please reach out to info@mideohealth.com.",
      );
      setWorking(false);
    }
  };

  // NAVIGATION FROM TANSTACK ROUTER
  const navigate = useNavigate();

  // LISTEN FOR COMPONENT UPDATE
  useEffect(() => {
    // HANDLE REDIRECT TO REQUESTED URL
    const requestedURL = window.localStorage.getItem('requestedURL');
    if (currentUser && requestedURL) {
      // ACCOUNT FOR DIFFERENCE BETWEEN PROD AND STAGING URLS
      const path = requestedURL.includes('com') ? requestedURL.split('com')[1] : requestedURL.split('app')[1];
      navigate({
        to: path,
        from: '/enroll',
      });
    } else if (currentUser?.uid && !requestedURL) {
      navigate({
        to: '/welcome',
        from: '/enroll',
      });
    }
  }, [currentUser, navigate]);

  return (
    <div>
      <div className="flex h-screen flex-col items-center justify-center">
        <img
          src="https://storage.googleapis.com/mideoid-console-public/logos/MIDEOhealth.png"
          alt="mideo_logo"
          className="h-36"
        />
        <div className="my-4 px-8">
          <p className="text-xl font-bold">
            This page is only intended for our corporate/organization partners with registered email addresses.
          </p>
        </div>
        <div className="my-2 px-8">
          <p className="text-xl font-bold">
            ALERT: Due to network restrictions, it is important that you avoid using your corporate network and/or a
            corporate-issued device to access the MIDEO Portal. If you experience an issue, please try accessing the
            MIDEO Portal from a personal device at home.
          </p>
        </div>
        <form>
          <FormInput
            id="email"
            handleBlur={() => {}}
            label="Email"
            name="username"
            value={email}
            handleChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
          <PasswordInput
            id="password"
            title="Password"
            password={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="flex flex-col">
            <Button
              id="submit"
              type="submit"
              onClick={(e) => handleLogin(e)}
              textContent="Login"
              disabled={working}
              working={working}
              workingText="Logging in..."
            />
            <RequestPasswordReset email={email} />
          </div>
        </form>
      </div>
    </div>
  );
}
